import { FC } from 'react';

import { ClockIcon } from '@/assets/icons';
import { Card, Tag } from '@/components/atoms';
import { CardContent } from '@/components/atoms/Card/Card';

type SurveyCardPreviewProps = {
  img: {
    src: string | undefined;
    alt: string;
  };
  title: string;
  description: string;
  questionCount: number;
  timeText: string;
};

export const SurveyCardPreview: FC<SurveyCardPreviewProps> = ({
  img,
  title,
  description,
  questionCount,
  timeText,
}) => {
  return (
    <Card className="rounded-[12px] p-0 group w-full overflow-hidden shadow-lg">
      <CardContent>
        <div>
          <img
            src={img.src}
            alt={img.alt}
            className="object-contain object-center w-full aspect-[600/200]"
          />
        </div>
        <div className="p-6">
          <div className="mb-4">
            <h3 className="text-body-24-semibold text-custom-warm-grey-800 mb-1">
              {title || 'Your title'}
            </h3>
            <p className="text-body-14-regular text-custom-warm-grey-500">
              {description || 'Your description'}
            </p>
          </div>
          <div className="flex items-center gap-4">
            <Tag
              label={`${questionCount} questions`}
              size="x-large"
              color="grey"
              type="outlined"
              className="bg-custom-warm-grey-50 outline-custom-warm-grey-200"
            />
            <div className="flex items-center gap-2">
              <span className="text-custom-warm-grey-500">
                <ClockIcon width={20} height={20} />
              </span>
              <p className="text-body-14-medium text-custom-warm-grey-700">{timeText}</p>
            </div>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};
